// removed by extract-text-webpack-plugin
module.exports = {"fileTypeThumb":"TMEUi8EvuLa55C-FdOFOq","corner":"_3bKQ0u34rsdR8HuA-AFqPZ","top":"_3Yhde0rFxD8y1J3-zVpsEv","bottom":"_2ygF7cvMZlcEMKbMBQr5bK","fileType":"_3zfzWW5qVidoUgIWNApVFs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FileTypeThumb/FileTypeThumb.scss
// module id = 1265
// module chunks = 1